import {
  CancellationActionEnum,
  ICancellationReason,
  IPauseReason,
} from "@smartrr/shared/entities/CancellationRelationship";
import React from "react";

import { ArchivedReason } from "./ArchivedReason";
import { ArchivedReasonsTableHead, CircledLetter, StyledTable } from "../CancellationReasonsSettings/styles";

interface Props {
  cancellationReasonInput?: ICancellationReason[] | undefined;
  pauseReasonInput?: IPauseReason[] | undefined;
  updateReason?: (
    id: string,
    action:
      | "updateReasonText"
      | "updateAction"
      | "updateReasonDiscount"
      | "archiveReason"
      | "updateHasCustomerPrompt",
    value: string | CancellationActionEnum | number | boolean
  ) => void;
  updatePauseReason?: (
    id: string,
    action: "updateReasonText" | "archiveReason" | "updateHasCustomerPrompt",
    value: string | boolean
  ) => void;
  pause?: boolean;
}

export const ArchivedReasonTable = ({
  cancellationReasonInput,
  updateReason,
  updatePauseReason,
  pause,
  pauseReasonInput,
}: Props) => {
  return (
    <StyledTable>
      <tr>
        <ArchivedReasonsTableHead>Archived reasons</ArchivedReasonsTableHead>
        {!pause && (
          <React.Fragment>
            <ArchivedReasonsTableHead>
              Retention Action
              <CircledLetter>ⓘ</CircledLetter>
            </ArchivedReasonsTableHead>
            <ArchivedReasonsTableHead>Discount</ArchivedReasonsTableHead>
          </React.Fragment>
        )}
        <ArchivedReasonsTableHead>
          Prompt
          <CircledLetter>ⓘ</CircledLetter>
        </ArchivedReasonsTableHead>
        <ArchivedReasonsTableHead>{""}</ArchivedReasonsTableHead>
      </tr>
      {pause
        ? pauseReasonInput?.map(pauseReason => {
            if (pauseReason.isArchived) {
              return (
                <ArchivedReason
                  key={pauseReason.id}
                  pauseReason={pauseReason}
                  updatePauseReason={updatePauseReason}
                  pause
                />
              );
            }
          })
        : cancellationReasonInput?.map(cancellationReason => {
            if (cancellationReason.isArchived) {
              return (
                <ArchivedReason
                  key={cancellationReason.id}
                  cancellationReason={cancellationReason}
                  updateReason={updateReason}
                />
              );
            }
          })}
    </StyledTable>
  );
};
